(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('procurementService', procurementService);

	procurementService.$inject = ['$http'];

	function procurementService($http) {
		var baseUrl = '/api/2/factndx/{0}';

		return {
			runProcurement: runProcurement
		};

		function runProcurement(itemForDetailedLog, siteId) {
			var url = String.format(baseUrl, siteId || globalConfig.factory.id) + '/RunProcurement';
			var params = {};
			if (itemForDetailedLog) {
				params['itemForDetailedLog'] = itemForDetailedLog;
			}
			if (itemForDetailedLog) {
				url += '?' + jQuery.param(params);
			}
			return $http.post(url)
				.then(runProcurementSuccess)
				.catch(runProcurementFailed);

			function runProcurementSuccess(response) {
				return true;
			}

			function runProcurementFailed(error) {
				return false;
			}
		}
	}
})();
